export const Skeleton = {
  baseStyle: {
    borderRadius: 4,
    willChange: 'opacity'
  }
}
